import React from 'react';
import PropTypes from 'prop-types';

import MuiTable from '@material-ui/core/Table';
import MuiTableBody from '@material-ui/core/TableBody';
import MuiTableRow from '@material-ui/core/TableRow';
import MuiTableCell from '@material-ui/core/TableCell';
import Box from 'components/atoms/Box/Box';

/**
 * Default Table component based on https://material-ui.com/components/tables/#dense-table
 * @param {} props All possible props can be found in docs https://material-ui.com/components/tables/#api
 */
export default function Table(props) {
  const { data, ...rest } = props;

  return (
    <Box mb={2}>
      <MuiTable size="small">
        <MuiTableBody>
          {data.map((item, index) => {
            return (
              <MuiTableRow key={index}>
                <MuiTableCell component="th" scope="row">
                  {item.name}
                </MuiTableCell>
                {/*TODO: Check with API how to handle measuring units (mg, g, IU) */}
                <MuiTableCell align="right">
                  {item.quantity ? item.quantity : '-'}
                </MuiTableCell>
                <MuiTableCell align="right">
                  {item.percentage ? `${item.percentage}` : '-'}
                </MuiTableCell>
              </MuiTableRow>
            );
          })}
        </MuiTableBody>
      </MuiTable>
    </Box>
  );
}

Table.propTypes = {
  /* Array of objects representing table rows/cells */
  data: PropTypes.any.isRequired,
};
